import {Button, Modal} from "react-bootstrap";
import {ProjectColors} from "../../Enums/Core/projectColors";
import React from 'react'

export default function ColorsLegendModal(props) {
    const tdStyle = {display: "flex", alignItems: 'center', alignContent: 'center'};

    return (
        <Modal className={'SettingModal'} dialogClassName={'modal-settings'} show={props.show} backdrop={true} onHide={() => props.setShow(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Color Legend</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <table style={{marginRight: "auto", marginLeft: "auto"}}>
                    <tr>
                        <th style={{width: '20%', paddingRight: '20px'}}>Color</th>
                        <th>Description</th>
                    </tr>
                    <tr>
                        <td style={tdStyle}>
                            <div style={{backgroundColor: 'rgba(165,17,1,0.8)', width: '50%', height: '20px'}}/>
                        </td>
                        <td>Major leak - needs attention</td>
                    </tr>
                    <tr>
                        <td style={tdStyle}>
                            <div style={{backgroundColor: 'rgba(255,69,49,0.8)', width: '50%', height: '20px'}}/>
                        </td>
                        <td>Major leak</td>
                    </tr>
                    <tr>
                        <td style={tdStyle}>
                            <div style={{backgroundColor: 'rgba(230,134,18,0.8)', width: '50%', height: '20px'}}/>
                        </td>
                        <td>Moderate leak - needs attention</td>
                    </tr>
                    <tr>
                        <td style={tdStyle}>
                            <div style={{backgroundColor: 'rgba(242,219,39,0.8)', width: '50%', height: '20px'}}/>
                        </td>
                        <td>Moderate leak</td>
                    </tr>
                    <tr>
                        <td style={tdStyle}>
                            <div style={{backgroundColor: 'rgba(238,66,169,0.8)', width: '50%', height: '20px'}}/>
                        </td>
                        <td>Minor leak - needs attention</td>
                    </tr>
                    <tr>
                        <td style={tdStyle}>
                            <div style={{width: '50%', height: '20px', border: 'solid 1px', borderColor: 'grey'}}/>
                        </td>
                        <td>Minor leak</td>
                    </tr>
                    <tr>
                        <td style={tdStyle}>
                            <div style={{backgroundColor: 'rgba(132,3,252,0.8)', width: '50%', height: '20px'}}/>
                        </td>
                        <td>Repeating leak</td>
                    </tr>
                </table>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={() => props.setShow(false)}>Close</Button>
            </Modal.Footer>
        </Modal>
    )
}
